var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6402 6.23177C15.0645 6.58534 15.1218 7.2159 14.7682 7.64018L9.76822 13.6402C9.58836 13.856 9.32599 13.9862 9.04531 13.999C8.76464 14.0117 8.49156 13.9058 8.29289 13.7071L5.29289 10.7071C4.90237 10.3166 4.90237 9.68341 5.29289 9.29289C5.68342 8.90236 6.31658 8.90236 6.70711 9.29289L8.9328 11.5186L13.2318 6.35981C13.5853 5.93553 14.2159 5.87821 14.6402 6.23177Z",
    fill: "#090B45"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckMark);
export default __webpack_public_path__ + "static/media/check-mark.62bcadfcff9b2bc6b9b5bf8e18f822a6.svg";
export { ForwardRef as ReactComponent };